import { ReactNode } from 'react';
import { Typography } from '@/shared/ui/Typography/Typography';
import { cn } from '@/shared/lib/utils';

type StateMessageProps = {
  title?: string;
  message: string;
  action?: ReactNode;
  className?: string;
};

export function StateMessage({ title, message, action, className }: StateMessageProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 text-center py-16 px-4 min-h-[40vh]',
        className
      )}
    >
      {title && (
        <Typography tag='h2' className='text-[24px] font-semibold md:text-[32px]'>
          {title}
        </Typography>
      )}
      <Typography className='text-[14px] text-[var(--black-grey)] md:text-[16px]'>
        {message}
      </Typography>
      {action}
    </div>
  );
}

